// Meeting type constants used across the application
export const MEETING_TYPES = {
  courtesy: { label: "Courtesy", color: "bg-slate-500/20 text-slate-400 border-slate-500/30" },
  meet_greet: { label: "Meet & Greet", color: "bg-green-500/20 text-green-400 border-green-500/30" },
  service_interview: { label: "Service Interview", color: "bg-blue-500/20 text-blue-400 border-blue-500/30" },
  follow_up: { label: "Follow Up", color: "bg-purple-500/20 text-purple-400 border-purple-500/30" },
  consulting: { label: "Consulting", color: "bg-amber-500/20 text-amber-400 border-amber-500/30" },
};

export const MEETING_FORMATS = {
  zoom: { label: "Zoom", color: "bg-purple-500/20 text-purple-400 border-purple-500/30" },
  in_person: { label: "In-Person", color: "bg-orange-500/20 text-orange-400 border-orange-500/30" },
};

export const DEFAULT_MEETING_TYPE = "courtesy";
export const DEFAULT_MEETING_FORMAT = "zoom";

export const getMeetingTypeLabel = (type) => {
  return MEETING_TYPES[type]?.label || MEETING_TYPES.courtesy.label;
};

export const getMeetingTypeColor = (type) => {
  return MEETING_TYPES[type]?.color || MEETING_TYPES.courtesy.color;
};

export const getMeetingFormatLabel = (format) => {
  return MEETING_FORMATS[format]?.label || MEETING_FORMATS.zoom.label;
};

export const getMeetingFormatColor = (format) => {
  return MEETING_FORMATS[format]?.color || MEETING_FORMATS.zoom.color;
};
